import React, { Component } from 'react';

import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';

import type { ALL_STEPS } from '~/consts/refund';

type RefundStep = (typeof ALL_STEPS)[number];

interface Props {
  stepToggle: (step: RefundStep) => void;
  stepBack: RefundStep;
}

export default class LinkBack extends Component<Props> {
  constructor(props: Props) {
    super(props);

    this.handler = this.handler.bind(this);
  }

  handler() {
    this.props.stepToggle(this.props.stepBack);
  }

  render() {
    return (
      <Button onClick={this.handler} variant="text" size="small" startIcon={<ArrowBack fontSize="small" />}>
        Back
      </Button>
    );
  }
}
